/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginStatusDto } from '../../models/login-status-dto';
import { OwnUserDto } from '../../models/own-user-dto';

export interface AuthControllerUpdateMyUser$Params {
      body: OwnUserDto
}

export function authControllerUpdateMyUser(http: HttpClient, rootUrl: string, params: AuthControllerUpdateMyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerUpdateMyUser.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginStatusDto>;
    })
  );
}

authControllerUpdateMyUser.PATH = '/api/auth/user';
